import {yupResolver} from "@hookform/resolvers/yup";
import {Space, Button} from "antd";
import {useState} from "react";
import {useForm} from "react-hook-form";
import {useSendPasswordChangeOtp} from "../../../react-query-hooks/settings";
import yup from "../../../utils/yup-extended";
import {CustomInputComponent} from "../../input/input-component";
import {StyledEmailUpdateFormContainer} from "../email-update-form/email-update-form.style";
import {VerifyPasswordModal} from "./verify-password-modal";

const PasswordUpdateForm = () => {
  return <PasswordUpdateFormV2 />;
};

const PasswordUpdateFormV2 = () => {
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const sendOtpMutation = useSendPasswordChangeOtp();

  const {
    handleSubmit,
    formState: {errors},
    watch,
    control,
    reset,
  } = useForm<{oldPassword: string}>({
    resolver: yupResolver(
      yup.object().shape({
        oldPassword: yup.string().required("Current password is required"),
      })
    ),
    mode: "onChange",
  });

  const onSubmit = async (values: {oldPassword: string}) => {
    sendOtpMutation.mutate(values.oldPassword, {
      onSuccess: () => {
        setCurrentPassword(values.oldPassword);
        setIsOtpModalVisible(true);
        reset();
      },
    });
  };

  const handleOtpSuccess = () => {
    setIsOtpModalVisible(false);
  };

  return (
    <div>
      <StyledEmailUpdateFormContainer>
        <h2 className="email-heading-text">Update Password</h2>
      </StyledEmailUpdateFormContainer>
      <form onSubmit={handleSubmit(onSubmit)} style={{marginTop: "2.4rem"}}>
        <Space direction="vertical" size={24} style={{display: "flex"}}>
          <CustomInputComponent
            id="oldPassword"
            name="oldPassword"
            type="password"
            placeholder="Current password"
            error={errors.oldPassword?.message}
            control={control}
          />
          <div>
            <Button
              disabled={Object.keys(errors).length > 0 || !watch("oldPassword")}
              loading={sendOtpMutation.isLoading}
              size="small"
              type="primary"
              htmlType="submit"
            >
              Change password
            </Button>
          </div>
        </Space>
      </form>
      <VerifyPasswordModal
        visible={isOtpModalVisible}
        currentPassword={currentPassword}
        onClose={() => {
          setIsOtpModalVisible(false);
        }}
        onSuccess={handleOtpSuccess}
      />
    </div>
  );
};

export {PasswordUpdateForm};
